import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./infopage.css";
library.add(fab);

const InfoPage = () => {
    return (
        <div className='info_page'>
            <div className='info_container'>
                <h2 className='info_title'>This Project is Developed by Soumyajit Pan</h2>
                <div className='icon_container'>
                    <FontAwesomeIcon icon={["fab", "linkedin"]} className='icon linkedin' />
                    <FontAwesomeIcon icon={["fab", "twitter"]} className='icon twitter' />
                    <FontAwesomeIcon icon={["fab", "telegram"]} className='icon teligram' />
                </div>
            </div>
        </div>
    )
}

export default InfoPage